import { uniqueId } from 'cadenza/utils/unique-id';

/** @deprecated Use a `<form-group>` to wire a control and its label. */
export function label (el: Element, { ariaLabel, ariaLabelledBy }: {
  ariaLabel?: string;
  ariaLabelledBy?: string | Element;
}) {
  if (ariaLabel) {
    el.setAttribute('aria-label', ariaLabel);
  }
  if (ariaLabelledBy) {
    if (ariaLabelledBy instanceof Element) {
      if (!ariaLabelledBy.id) {
        ariaLabelledBy.id = uniqueId();
      }
      ariaLabelledBy = ariaLabelledBy.id;
    }
    el.setAttribute('aria-labelledby', ariaLabelledBy);
  }
}

function ariaBoolean (el: Element, property: string): boolean;
function ariaBoolean (el: Element, property: string, value: boolean): void;
function ariaBoolean (el: Element, property: string, value?: boolean) {
  const attribute = `aria-${property}`;
  if (arguments.length === 2) { // get
    return (el.getAttribute(attribute) === 'true');
  }

  // set
  if (value) {
    el.setAttribute(attribute, 'true');
  } else {
    el.removeAttribute(attribute);
  }
}

export { ariaBoolean };
